import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaPositions = React.lazy(() =>
    import('../NebulaPositions')
);
const nebulaPositionsRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_POSITIONS_PAGE,
        element: <NebulaPositions />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaPositionsRoutesRegistry;
